module.exports = __webpack_public_path__ + "static/media/logout-icon.f70ff445.svg";